/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class SavingsPlanUtilizationMetric {
    getFixupPrototypeFunction() { return SavingsPlanUtilizationMetric.fixupPrototype; }

    static newInstance(model: Partial<SavingsPlanUtilizationMetric>): SavingsPlanUtilizationMetric {
        let obj = Object.assign(new SavingsPlanUtilizationMetric(), model);
        SavingsPlanUtilizationMetric.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<SavingsPlanUtilizationMetric>): SavingsPlanUtilizationMetric {
        if (!model) return null;
        return SavingsPlanUtilizationMetric.newInstance(<SavingsPlanUtilizationMetric> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: SavingsPlanUtilizationMetric) {
        if (!obj) return;

        models.SavingsPlanUtilizationMetric.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: SavingsPlanUtilizationMetric): boolean {
        Object.setPrototypeOf(obj, SavingsPlanUtilizationMetric.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.avg_utilization_percentage === undefined) {
            this.avg_utilization_percentage = 0;
        }
        if (this.max_utilization_percentage === undefined) {
            this.max_utilization_percentage = 0;
        }
        if (this.min_utilization_percentage === undefined) {
            this.min_utilization_percentage = 0;
        }
        if (this.utilization_percentage === undefined) {
            this.utilization_percentage = 0;
        }
        if (this.total_commitment === undefined) {
            this.total_commitment = 0;
        }
        if (this.used_commitment === undefined) {
            this.used_commitment = 0;
        }
        if (this.unused_commitment === undefined) {
            this.unused_commitment = 0;
        }
        if (this.net_savings === undefined) {
            this.net_savings = 0;
        }
        if (this.on_demand_cost === undefined) {
            this.on_demand_cost = 0;
        }
        if (typeof this.usage_date === "string") {
            this.usage_date = new Date(<string><any>this.usage_date);
        }
    }

    /**
     * Date of the utilization record
     */
    usage_date: Date;

    /**
     * Average utilization percentage for the day
     */
    avg_utilization_percentage: number;

    /**
     * Maximum utilization percentage for the day
     */
    max_utilization_percentage: number;

    /**
     * Minimum utilization percentage for the day
     */
    min_utilization_percentage: number;

    /**
     * Raw utilization percentage for the day
     */
    utilization_percentage: number;

    /**
     * Total commitment amount for the day
     */
    total_commitment: number;

    /**
     * Used commitment amount for the day
     */
    used_commitment: number;

    /**
     * Unused commitment amount for the day
     */
    unused_commitment: number;

    /**
     * Net savings amount for the day
     */
    net_savings: number;

    /**
     * On-demand cost equivalent for the day
     */
    on_demand_cost: number;

}
